export const wiki = [
  {
    id: "wiki-001",
    title: "Структура команды и процессы разработки",
    author: { id: "user-012", name: "Владимир Никитин" },
    created: "2023-01-15T10:00:00",
    updated: "2023-04-22T14:30:00",
    url: "/wiki/team-structure",
    summary: `Документация по структуре команды, ролям и обязанностям, а также основным процессам разработки. Включает описание методологии Agile, которую мы используем, процессы Code Review, CI/CD и политики ветвления.`,
    tags: ["команда", "процессы", "методология", "agile", "onboarding"]
  },
  {
    id: "wiki-002",
    title: "Архитектура микросервисов",
    author: { id: "user-004", name: "Екатерина Смирнова" },
    created: "2023-02-10T15:45:00",
    updated: "2023-04-16T11:20:00",
    url: "/wiki/microservices-architecture",
    summary: `Обзор архитектуры микросервисов проекта, включая схемы взаимодействия, API Gateway, систему сервисной регистрации и обнаружения, механизмы отказоустойчивости и масштабирования.`,
    tags: ["архитектура", "микросервисы", "api", "масштабирование"]
  },
  {
    id: "wiki-003",
    title: "Использование GraphQL в проекте",
    author: { id: "user-001", name: "Алексей Петров" },
    created: "2023-03-05T09:30:00",
    updated: "2023-04-10T16:15:00",
    url: "/wiki/graphql-guide",
    summary: `Руководство по использованию GraphQL в проекте. Схема, запросы, мутации, подписки. Лучшие практики оптимизации производительности, кэширования и обработки ошибок.`,
    tags: ["graphql", "api", "frontend", "backend", "оптимизация"]
  },
  {
    id: "wiki-004",
    title: "Стратегия мобильной разработки",
    author: { id: "user-005", name: "Иван Кузнецов" },
    created: "2023-02-20T13:00:00",
    updated: "2023-04-20T10:45:00",
    url: "/wiki/mobile-strategy",
    summary: `Стратегия мобильной разработки, включающая подход к разработке приложений для iOS и Android, использование React Native, интеграцию с API, аналитику и метрики, А/B тестирование.`,
    tags: ["mobile", "react-native", "ios", "android", "метрики"]
  },
  {
    id: "wiki-005",
    title: "Оптимизация производительности веб-приложения",
    author: { id: "user-009", name: "Андрей Соколов" },
    created: "2023-03-15T11:30:00",
    updated: "2023-04-05T14:20:00",
    url: "/wiki/web-performance",
    summary: `Гайд по оптимизации производительности веб-приложения. Включает техники оптимизации загрузки ресурсов, рендеринга, работы JavaScript, управление состоянием, кэширования, предзагрузки данных.`,
    tags: ["performance", "frontend", "оптимизация", "web vitals", "кэширование"]
  },
  {
    id: "wiki-006",
    title: "Процесс онбординга для новых сотрудников",
    author: { id: "user-011", name: "Елена Павлова" },
    created: "2023-01-25T10:15:00",
    updated: "2023-04-21T09:30:00",
    url: "/wiki/onboarding",
    summary: `Детальное описание процесса онбординга для новых сотрудников. Включает чек-листы для первого дня, первой недели и первого месяца, информацию о необходимых доступах, основных системах и инструментах, список обязательных тренингов.`,
    tags: ["onboarding", "HR", "процессы", "обучение"]
  },
  {
    id: "wiki-007",
    title: "Безопасность и соответствие стандартам PCI DSS",
    author: { id: "user-015", name: "Павел Соловьев" },
    created: "2023-03-10T14:45:00",
    updated: "2023-04-26T11:30:00",
    url: "/wiki/security-pci-dss",
    summary: `Руководство по обеспечению безопасности в проекте и соответствию стандартам PCI DSS для обработки платежей. Включает требования к хранению данных, шифрованию, авторизации, аутентификации, логированию и мониторингу.`,
    tags: ["безопасность", "PCI DSS", "шифрование", "аудит", "платежи"]
  }
]; 